import { useState } from "react";

// #CUST_PICKER_V1 (2026-09-03) — Bill: "How do we keep various name entries from being entered...
// there are so many having to merge?" Root cause: the Customer field on the Job List (New Job +
// Edit Job) was plain free text — every job re-typed the name from scratch, so any typo,
// abbreviation, or spacing variant became a brand-new spelling that fragmented every rollup
// downstream (Job Cost, Estimating, Revenue). This locks entry to the existing customer list
// (already resolved through the Customer Alias tool's merges) with an explicit "+ Add new
// customer" step for the rare case it's genuinely a first-time customer — so new duplicates stop
// getting created at the source instead of needing to be merged after the fact.
export default function CustomerPicker({ value, onChange, options, placeholder, style }) {
  const [adding, setAdding] = useState(false);
  const [draft, setDraft] = useState('');

  // Keep an existing/legacy value visible and selected even if it isn't (yet) in the canonical
  // options list — never silently blank out a job's customer just because this picker is new.
  const opts = (() => {
    const set = new Set((options || []).filter(Boolean));
    if (value) set.add(value);
    return [...set].sort((a, b) => a.localeCompare(b));
  })();

  const commit = () => {
    const v = draft.trim();
    if (!v) return;
    onChange(v);
    setAdding(false);
    setDraft('');
  };

  if (adding) {
    return (
      <div style={{ display: 'flex', gap: 6, alignItems: 'center', ...style }}>
        <input autoFocus value={draft} onChange={e => setDraft(e.target.value)}
          placeholder="New customer name…"
          onKeyDown={e => {
            if (e.key === 'Enter') { e.preventDefault(); commit(); }
            if (e.key === 'Escape') { setAdding(false); setDraft(''); }
          }}
          style={{ flex: 1, minWidth: 0 }} />
        <button type="button" onClick={commit} disabled={!draft.trim()}
          style={{ fontWeight: 700, cursor: draft.trim() ? 'pointer' : 'not-allowed' }}>Add</button>
        <button type="button" onClick={() => { setAdding(false); setDraft(''); }}
          style={{ cursor: 'pointer' }}>Cancel</button>
      </div>
    );
  }

  return (
    <select value={value || ''} onChange={e => {
        if (e.target.value === '__NEW__') { setAdding(true); setDraft(''); }
        else { onChange(e.target.value); }
      }}
      style={{ width: '100%', ...style }}>
      <option value="" disabled>{placeholder || 'Select customer…'}</option>
      <option value="__NEW__">+ Add new customer…</option>
      {opts.map(o => <option key={o} value={o}>{o}</option>)}
    </select>
  );
}
